module.exports = __webpack_public_path__ + "static/media/boss-tuagom-pic.739c8a01.png";